import React, { useState } from "react";
import { Card, Col, Row, Tab, Tabs } from "react-bootstrap";
import ManualVocabulary from "./ManualVocabulary";
import AiGeneratedVocabulary from "./AiGeneratedVocabulary";
import PageHeading from "components/shared/PageHeading";
import upload from "../../../assets/uploadexercise.png";
import generatefromai from "../../../assets/generateai.png";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const CreateVocabulary = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const cardData = [
    {
      title: "Create study set (AI Generated)",
      imgSrc: generatefromai,
    },
    {
      title: "Create study set (Manually)",
      imgSrc: upload,
    },
  ];
  const handleShowModal = (title) => {
    if (title === "Create study set (AI Generated)") {
      navigate("/vocabulary/create-vocabulary/AI");
    } else if (title === "Create study set (Manually)") {
      navigate("/vocabulary/create-vocabulary/manually");
    }
  };
  const [key, setKey] = useState(1);
  return (
    <>
      <PageHeading heading={"Create Vocabulary"} />
      <Row className="mt-4">
        {cardData.map((card, index) => (
          <Col key={index} xs={12} sm={6} md={3} lg={3}>
            <Card
              className="m-0 mb-2 border-0 text-center reading-categories-cards"
              style={{ cursor: "pointer" }}
              onClick={() => handleShowModal(card.title)}
            >
              <Card.Img
                variant="top"
                src={card.imgSrc}
                style={{ height: "200px" }}
              />
              <Card.Body className="mt-3" style={{ minHeight: "80px" }}>
                <Card.Title style={{ fontSize: "18px" }}>
                  {t(card.title)}
                </Card.Title>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </>
  );
};

export default CreateVocabulary;
